'use client';

// Package Imports
import { Dispatch } from 'react';

// Context Defaults
import { defaultOrderState } from '@/lib/context/orderDefaults';

// Context Imports
import { ActionTypes } from '@/lib/context/actionTypes';
import { ActionMap } from '@/lib/context/actionMap';

// Types Imports
import { OrderState } from '@/lib/types/orderState';

// Define Types
type CreateOrderAction = {
  type: ActionTypes.CreateOrder;
  payload: {
    order: OrderState;
  };
};

type UpdateOrderAction = {
  type: ActionTypes.UpdateOrder;
  payload: {
    order: OrderState;
  };
};

type OrderPayload = {
  [ActionTypes.CreateOrder]: {
    order: OrderState;
  };
  [ActionTypes.UpdateOrder]: {
    order: OrderState;
  };
};

export type OrderActions = ActionMap<OrderPayload>[keyof ActionMap<OrderPayload>];

export const createOrder = (dispatch: Dispatch<CreateOrderAction>, order: OrderState) => {
  dispatch({type: ActionTypes.CreateOrder, payload: {order: order}});
};

export const updateOrder = (dispatch: Dispatch<UpdateOrderAction>, order: OrderState ) => {
  dispatch({type: ActionTypes.UpdateOrder, payload: {order: order}});
};

export const resetOrder = (dispatch: Dispatch<UpdateOrderAction>) => {
  dispatch({type: ActionTypes.UpdateOrder, payload: {order: defaultOrderState}});
};
